function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { showPopup } from 'oskari-ui/components/window';
import { BaseLayerList } from './LayerSelectionPopup/BaseLayerList';
import { LayerList } from './LayerSelectionPopup/LayerList';
import { Message } from 'oskari-ui';
import { LocaleProvider } from 'oskari-ui/util';
import { getPopupOptions } from '../pluginPopupHelper';
import styled from 'styled-components';
import { ThemeProvider } from 'oskari-ui/util';
var BUNDLE_NAME = 'MapModule';
var POPUP_ID = 'LayerSelection';
var Content = styled('div').withConfig({
  displayName: "LayerSelectionPopup__Content",
  componentId: "sc-1r2tx4p-0"
})(["margin:12px 24px 24px;"]);
var LayerSelectionPopup = function LayerSelectionPopup(_ref) {
  var baseLayers = _ref.baseLayers,
    layers = _ref.layers,
    showMetadata = _ref.showMetadata,
    styleSelectable = _ref.styleSelectable,
    setLayerVisibility = _ref.setLayerVisibility,
    selectStyle = _ref.selectStyle;
  var selectBaseLayer = function selectBaseLayer(layer) {
    return setLayerVisibility(layer, true, true);
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(LocaleProvider, {
    value: {
      bundleKey: BUNDLE_NAME
    }
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(BaseLayerList, {
    layers: baseLayers,
    showHeading: layers && layers.length > 0,
    showMetadata: showMetadata,
    styleSelectable: styleSelectable,
    selectLayer: selectBaseLayer,
    selectStyle: selectStyle
  }), /*#__PURE__*/React.createElement(LayerList, {
    layers: layers,
    showHeading: baseLayers && baseLayers.length > 0,
    showMetadata: showMetadata,
    styleSelectable: styleSelectable,
    setLayerVisibility: setLayerVisibility,
    selectStyle: selectStyle
  }))));
};
export var showLayerSelectionPopup = function showLayerSelectionPopup(baseLayers, layers, onClose, showMetadata, styleSelectable, setLayerVisibility, selectStyle, pluginLocation) {
  var options = getPopupOptions({
    getName: function getName() {
      return POPUP_ID;
    },
    getLocation: function getLocation() {
      return pluginLocation;
    }
  });
  var controls = showPopup(/*#__PURE__*/React.createElement(Message, {
    bundleKey: BUNDLE_NAME,
    messageKey: "plugin.LayerSelectionPlugin.title"
  }), /*#__PURE__*/React.createElement(LayerSelectionPopup, {
    baseLayers: baseLayers,
    layers: layers,
    showMetadata: showMetadata,
    styleSelectable: styleSelectable,
    setLayerVisibility: setLayerVisibility,
    selectStyle: selectStyle
  }), onClose, options);
  return _objectSpread(_objectSpread({}, controls), {}, {
    update: function update(baseLayerData, layerData, showMetadata, styleSelectable) {
      return controls.update(/*#__PURE__*/React.createElement(Message, {
        bundleKey: BUNDLE_NAME,
        messageKey: "plugin.LayerSelectionPlugin.title"
      }), /*#__PURE__*/React.createElement(LayerSelectionPopup, {
        baseLayers: baseLayerData,
        layers: layerData,
        showMetadata: showMetadata,
        styleSelectable: styleSelectable,
        setLayerVisibility: setLayerVisibility,
        selectStyle: selectStyle
      }));
    }
  });
};
LayerSelectionPopup.propTypes = {
  baseLayers: PropTypes.arrayOf(PropTypes.object),
  layers: PropTypes.arrayOf(PropTypes.object),
  showMetadata: PropTypes.bool.isRequired,
  setLayerVisibility: PropTypes.func.isRequired,
  selectStyle: PropTypes.func.isRequired,
  styleSelectable: PropTypes.bool.isRequired
};